import Head from "next/head";
import Link from "next/link";
import { Button } from "@/components/Button";
import { ExternalLinkIcon } from "@heroicons/react/outline";
import { Layout } from "@/components/Layout";
import { PageTitle } from "@/components/PageTitle";
import { SectionContainer } from "@/components/SectionContainer";
import { useRouter } from "next/router";
import { stringify } from "querystring";

export default function Donate() {
  const pageTitle = "Donate to Govern For California";
  const router = useRouter();

  // if a query string is provided, append it to the Credit Card and Appreciated
  // securities links (for EveryAction optimized ask amounts and conversion)
  const queryString =
    Object.keys(router.query).length > 0 ? `?${stringify(router.query)}` : "";

  return (
    <>
      <Head>
        <title>{`${pageTitle} - Govern For California`}</title>
        <meta name="description" content="Donate to Govern For California" />
      </Head>
      <Layout mobileTitle="Donate to GFC">
        <PageTitle title={pageTitle} />
        <SectionContainer bgColor={"bg-white"}>
          <div className="sm:mt-6">
            <p className="text-lg text-gray-800">
              <span className="font-semibold">
                Help fix California by countering special interest influence
                over lawmakers.
              </span>{" "}
              {/* There are two ways you can support GFC. */}
            </p>
          </div>
          <div className="text-md mt-3 text-gray-500">
            Donations to Govern For California are not deductible as charitable
            donations for federal income tax purposes.
          </div>
          {/* <div className="mt-6 rounded-md bg-brand-icon/20 p-5"> */}
          {/* <div>
              Make a donation to our non-profit organization to support policy
              advocacy and operating expenses. These donations are not publicly
              reported and there are no minimum or maximum amounts, nor are they
              subject to pay-to-play restrictions.
            </div> */}
          <div className="mt-6 text-base md:text-lg">
            <Button
              className="whitespace-nowrap"
              href={`/donate/501c4${queryString}`}
            >
              Make a Donation →
            </Button>
          </div>
          {/* </div> */}
          {/* <div className="mt-12 rounded-md bg-slate-100 p-5">
            <div>
              Become a political philanthropist by making a donation to our
              Statewide PAC. The PAC makes contributions to legislators and
              candidates for the state legislature which solidifies GFC’s role
              as a permanent counter to special interests in Sacramento.
              Donations are publicly reported, are limited by law to $9,100 per
              person per year, and are subject to pay-to-play restrictions.
            </div>
            <div className="mt-4 text-base md:text-lg">
              <Button
                className="whitespace-nowrap"
                xhref={`https://action.governforcalifornia.org/a/donate_to_statewide_chapter${queryString}`}
                target="_blank"
                rel="noreferrer"
              >
                Make a Political Donation →
              </Button>
            </div>
          </div> */}
        </SectionContainer>
      </Layout>
    </>
  );
}
